import { jsxs, jsx } from "react/jsx-runtime";
import { Popover, Typography, Button } from "@mui/material";
import { useIgnoreForm } from "./CallCardIgnoreForm.helpers.js";
import { StyledTextField, ButtonsWrapper } from "./CallCardIgnoreForm.styles.js";
import "react-hook-form";
import "@hookform/resolvers/yup";
import "yup";
import "@mui/material/styles";
const CallCardIgnoreForm = ({ onClose, onSubmit, buttonRef, isOpen, labels }) => {
  const {
    register,
    formState: { isDirty, isValid, isSubmitting },
    handleSubmit
  } = useIgnoreForm();
  const handlePopoverClick = (event) => {
    event.stopPropagation();
  };
  const disabled = !isDirty || !isValid || isSubmitting;
  return /* @__PURE__ */ jsxs(
    Popover,
    {
      open: isOpen,
      anchorEl: buttonRef,
      onClick: handlePopoverClick,
      onClose,
      PaperProps: {
        sx: {
          padding: 1
        }
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      children: [
        /* @__PURE__ */ jsx(Typography, { variant: "Lato Emphasized 2", children: labels.ignoreCall }),
        /* @__PURE__ */ jsxs("form", { onSubmit: handleSubmit(onSubmit), children: [
          /* @__PURE__ */ jsx(
            StyledTextField,
            {
              ...register("comment"),
              placeholder: labels.placeholder,
              multiline: true,
              fullWidth: true,
              rows: 5,
              variant: "filled",
              required: true,
              InputProps: { disableUnderline: true },
              disabled: isSubmitting
            }
          ),
          /* @__PURE__ */ jsxs(ButtonsWrapper, { children: [
            /* @__PURE__ */ jsx(Button, { onClick: onClose, size: "xs", variant: "borderless", children: labels.cancel }),
            /* @__PURE__ */ jsx(Button, { type: "submit", size: "xs", disabled, children: labels.submit })
          ] })
        ] })
      ]
    }
  );
};
export {
  CallCardIgnoreForm
};
